function h(r) {
  return void 0 === r ? void 0 : "function" == typeof r ? r() : r;
}

function mjn(r, n, t) {
  var e = n.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split(".");

  try {
    for (var i = 0; i < e.length;) {
      if (!(e[i] in r)) return h(t);
      r = r[e[i]], i++;
    }

    return void 0 === r ? void 0 : r;
  } catch (r) {
    return h(t);
  }
}

export default mjn;